<template>
  <div class="page-container">
    <div class="row ml-1">
      <h4 class="mb-4 mr-2">Lista przedstawicieli handlowych</h4>
      <div>
        <b-button size="sm" @click="add">
          <span data-feather="plus"></span>
          Dodaj przedstawiciela handlowego
        </b-button>
      </div>
    </div>
    <b-table
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      show-empty
      stacked="md"
      :current-page="currentPage"
      :per-page="perPage"
    >
      <template v-slot:cell(api_keys)="{ item }">
        {{
          JSON.parse(item.api_keys)
            .map(key => allowedApiKeys[key])
            .join(', ')
        }}
      </template>
      <template v-slot:cell(actions)="{ item }">
        <b-button-group>
          <b-button class="btn-primary mr-1" size="sm" @click="edit(item)">Edytuj</b-button>
          <b-button class="btn-danger mr-1" size="sm" @click="remove(item)">Usuń</b-button>
        </b-button-group>
      </template>
    </b-table>

    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'All',
  async mounted() {
    const vm = this
    await vm.fetchAllowedApiKeys()
    vm.list()
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', label: 'Imię', sortable: true },
        { key: 'lastname', label: 'Nazwisko', sortable: true },
        { key: 'api_keys', label: 'Lokalizacje' },
        { key: 'created_at', label: 'Data utworzenia', sortable: true },
        { key: 'updated_at', label: 'Data ostatniej edycji', sortable: true },
        { key: 'actions', label: '' }
      ],
      currentPage: 1,
      totalRows: 0,
      perPage: 6,
      sortBy: '',
      sortDesc: false,
      allowedApiKeys: {}
    }
  },
  watch: {
    items() {
      this.updateUI()
    }
  },
  methods: {
    async fetchAllowedApiKeys() {
      const vm = this
      return vm.$http.post('e-zacma/get-allowed-api-keys').then(response => {
        const apiKeys = response.data
        // eslint-disable-next-line no-restricted-syntax
        for (const key of apiKeys) {
          vm.allowedApiKeys[key.api_key] = key.name
        }
      })
    },
    list() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'list-visit-type-groups')
      vm.$http
        .post('e-zacma/sales-representative/all')
        .then(response => {
          vm.items = response.data
        })
        .catch(() => {
          vm.$toast.error({
            message: 'Wystapił błąd podczas próby pobrania listy organizacji.'
          })
        })
        .then(() => {
          vm.$store.commit('removePageLoaderEvent', 'list-visit-type-groups')
        })
    },
    edit(item) {
      this.$router.push({ name: 'e-zacma-sales-representative-modify', params: { id: item.id } })
    },
    add() {
      this.$router.push({ name: 'e-zacma-sales-representative-create' })
    },
    show(item) {
      this.$router.push({ name: 'e-zacma-sales-representative-view', params: { id: item.id } })
    },
    remove(item) {
      const vm = this
      vm.$bvModal
        .msgBoxConfirm(
          `Czy napewno chcesz skasować przedstawiciela "${item.name} ${item.lastname}"?`,
          {
            title: 'Usuwanie przestawiciela handlowego',
            okVariant: 'danger',
            okTitle: 'Tak',
            cancelTitle: 'Nie',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(decision => {
          if (decision) {
            vm.$store.commit('addPageLoaderEvent', 'delete-sales-representative')
            vm.$http
              .post('e-zacma/sales-representative/delete', { id: item.id })
              .then(() => {
                vm.list()
                vm.$toast.success({
                  message: `Przedstawiciel handlowy o nazwie "${item.name}" została skasowana.`
                })
              })
              .catch(e => vm.$error())
              .finally(() => {
                vm.$store.commit('removePageLoaderEvent', 'delete-sales-representative')
              })
          }
        })
    },
    updateUI() {
      this.totalRows = this.items.length
    }
  }
}
</script>

<style scoped></style>
